<template>
  <div class="vehicle_tree">
    <div v-show="sidebar.opened" style="margin: 20px; position: relative">
      <div class="header">
        <span>{{ $t("carlineBinding.vehiclelist") }}</span>
        <i class="iconfont icon-icon_buslist_expan toggle_icon" @click="toggleSideBar"></i>
      </div>

      <el-input v-model="searchKey" clearable :placeholder="$t('public.vehicleInputTips')" size="small"
        style="margin-top: 16px; margin-bottom: 16px">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <div v-if="searchVehicls.length > 0" style="
          position: absolute;
          top: 70px;
          left: 0;
          right: 0;
          z-index: 1000;
          background: #e8f0ff;
        ">
        <!--搜索结果-->
        <div v-for="i in searchVehicls" :key="i.id" class="search_vehicle_item" @click="selectedVehicle(i.id)">
          <div style="font-size: 12px; color: #0f1a3a">
            {{ $t("vehicle.carNo") }}：{{ i.vehicleName }}
          </div>
          <div style="font-size: 12px; color: #0f1a3a; margin-top: 10px">
            {{ $t("vehicle.DeviceNo") }}：{{ i.mobile }}
          </div>
          <div style="font-size: 12px; color: #0f1a3a; margin-top: 10px">
            {{ $t("vehicle.VINCode") }}：{{ i.vincode }}
          </div>
          <div style="font-size: 12px; color: #0f1a3a; margin-top: 10px">
            {{ $t("vehicle.ManufactureNo") }}：{{ i.manuID }}
          </div>
        </div>
      </div>
      <div>
        <el-tree id="el-tree" ref="tree" :default-expand-all="defaultExpandAll" style="background-color: transparent"
          show-checkbox :data="data" node-key="id" @check="handleCheckChange">
          <span slot-scope="{ node, data }">
            <el-tooltip v-if="data.treeLevel != 5"
              :content="data.name + '(' + calcTreeCount(data) + '/' + data.totalCount + ')'" placement="top">
              <span class="tree_folder">{{ data.name }}({{ calcTreeCount(data) }}/{{
                data.totalCount
              }})</span>
            </el-tooltip>
            <el-tooltip v-else :content="data.name" placement="top">
              <span class="tree_file" @contextmenu.prevent="onContextmenu($event, data)"
                @click="handleVehicleClick(data)" @dblclick="onMonitorVehicle(data)"
                :class="{ online: data.isOnLine != 0 }">
                <i class="iconfont icon-icon_bus_list"></i>{{ data.vehicleName }}</span>
            </el-tooltip>
          </span>
        </el-tree>
      </div>
    </div>
    <div v-show="!sidebar.opened" style="text-align: center; margin-top: 20px">
      <i class="iconfont icon-icon_buslist_colla toggle_icon" @click="toggleSideBar"></i>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import { getVehicles } from "@/utils/auth";

export default {
  components: {},
  data() {
    return {
      defaultExpandAll: true,
      checkedkeysobject: {},
      data: [],
      searchKey: "", //搜索车辆
      searchVehicls: [], //搜索到的车辆
      vids: [], //全部车辆ID车辆
      timerOnline: null, //定时器，1分钟一次，通过websocket获取车辆的在线状态
    };
  },
  watch: {
    searchKey() {
      // console.log(this.searchKey)
      if (this.searchKey) {
        this.searchVehicles();
      } else {
        this.searchVehicls = [];
      }
    },
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      vehicles: (state) => state.app.vehicles,
    }),
  },
  destroyed() {
    this.socketClient.DetachEvent(
      "VelOnlineStateReq",
      this.socketClient.eventType.onVelOnlineStateAck
    );
    //清除定时器
    if (this.timerOnline)
      clearInterval(this.timerOnline);
  },
  methods: {
    handleVehicleClick(data) {
      // 获取当前节点是否已选中
      const isChecked = this.$refs.tree.getCheckedKeys().includes(data.id);
      // 如果已选中则取消选中，否则选中该节点
      this.$refs.tree.setChecked(data.id, !isChecked);
    },
    onMonitorVehicle(data) {
      this.$refs.tree.setCheckedKeys([data.id]);

      //保持到缓存
      localStorage.setItem("monitor_vehicle", JSON.stringify(data));
      //传入终端编号
      // console.log(this.$route.path)
      //如果路由已经存在，就不要再处理了
      if (this.$route.path.indexOf("/vmonitor/locateVehicle") > -1) {
        return;
      }
      this.handleCheckChange();
      this.$router.push("/vmonitor/locateVehicle?vid=" + data.nodeValue);
    },
    onContextmenu(event, data) {

      //右键菜单
      this.$contextmenu({
        items: [
          {
            label: this.$t("vehicletrack.page_title"),
            onClick: () => {
              //弹窗显示轨迹信息
              // console.log("轨迹回放");
              this.$bus.$emit("openRightDrawer", {
                command: "SingleVehicleTrack",
                vehicleInfo: data,
              });
            },
          },
          {
            label: this.$t("locateVehicle.视频监控"),
            onClick: () => {
              //弹窗显示视频监控
              this.$bus.$emit("openRightDrawer", {
                command: "SingleVehicleVedioMonitor",
                vehicleInfo: data,
              });
              // this.$refs.vehicle_video.open();

              // console.log("视频监控");
            },
          },
          // {
          //   label: "图片抓拍",
          //   onClick: () => {
          //     //弹窗显示图片抓拍
          //     console.log("图片抓拍");
          //   },
          // },
          {
            label: this.$t("locateVehicle.page_title"),
            onClick: () => {
              //打开位置监控模块功能
             
              this.$refs.tree.setCheckedKeys([data.id]);

              //保持到缓存
              localStorage.setItem("monitor_vehicle", JSON.stringify(data));
              //传入终端编号
              //如果路由已经存在，就不要再处理了
              // console.log(this.$route.path)
              if (this.$route.path.indexOf("/vmonitor/locateVehicle") > -1) {
                return;
              }
              this.handleCheckChange();
              this.$router.push(
                "/vmonitor/locateVehicle?vid=" + data.nodeValue
              );
            },
          },
          {
            label: this.$t("locateVehicle.消息发送"),
            onClick: () => {
              this.$bus.$emit("openRightDrawer", {
                command: "SingleVehicleMsg",
                vehicleInfo: data,
              });
              //弹窗显示消息发送
              // console.log("消息发送");
            },
          },
        ],
        event,
        //x: event.clientX,
        //y: event.clientY,
        // customClass: "custom-class",
        zIndex: 3,
        minWidth: 130,
      });
      return false;
    },
    selectedVehicle(id) {
      //选中车辆
      this.$refs.tree.setCheckedKeys([id]);
      this.searchVehicls = [];
      this.handleCheckChange();
      
    },
    searchVehicles() {
      var v = getVehicles();
      var searchKey = this.searchKey;

      if (v) {
        var vlist = JSON.parse(v);
        var p_map = [];
        vlist.forEach((e) => {
          if (e.treeLevel == 5) {
            if (
              e.vehicleName.indexOf(searchKey) > -1 ||
              e.mobile.indexOf(searchKey) > -1 ||
              e.vincode.indexOf(searchKey) > -1 ||
              e.manuID.indexOf(searchKey) > -1
            ) {
              p_map.push(e);
            }
          }
        });
        // var p_map = vlist.filter((e) => {

        //     return e.treeLevel == 5 && (e.vehicleName.indexOf(searchKey) > -1 || e.mobile.indexOf(searchKey) > -1 || e.vincode.indexOf(searchKey) > -1 || e.manuID.indexOf(searchKey) > -1);

        // });
        // console.log(p_map)
        if (p_map.length > 0) {
          this.searchVehicls = p_map;
        }
      }
    },
    calcTreeCount(node) {
      var online = 0;

      if (node && node.children && node.children.length > 0)
        node.children.forEach((element) => {
          online += this.calcTreeCount(element);

          if (element.treeLevel && element.treeLevel == 5) {
            var t = this.vehicles.tree[element.id];
            if (t && t.isOnLine != 0) online += 1;
          }
        });
      return online;
    },
    initTreeData() {
      var data = [];
      if (this.vehicles.tree) {
        var result = this.loopVehicleTree(0, this.vehicles.data);
        var p = this.loopVehicleTree(1, this.vehicles.data);
        // if(!p) p = [];
        // if(p[0].length ==0) this.defaultExpandAll = true;
        // console.log(this.defaultExpandAll )
        if (result) {
          data = [...result[0], ...p[0]];
        }
      }
      this.data = data;
    },
    handleCheckChange(data, checkedStatus, indeterminate) {
      // @check 事件提供三个参数：
      // data: 当前节点数据
      // checkedStatus: 当前节点是否被选中
      // indeterminate: 当前节点是否半选

      // 获取所有选中的节点
      const checkedNodes = this.$refs.tree.getCheckedNodes();
      const checkedLeafNodes = [];

      // 过滤出所有叶子节点（treeLevel == 5）
      checkedNodes.forEach(node => {
        if (node.treeLevel == 5) {
          checkedLeafNodes.push(node);
        }
      });

      // 更新 checkedkeysobject
      this.checkedkeysobject = {};
      checkedLeafNodes.forEach(node => {
        this.checkedkeysobject[node.id] = node;
      });

        // console.log(this.checkedkeysobject)
      // 一次性更新选中的值
      this.$store.dispatch(
        "app/updateSelectedVehicles",
        this.checkedkeysobject
      );
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    loopVehicleTree(pid, source) {
      var data = [];
      var online = 0;
      var total = 0;
      var rootNode = source.filter((r) => {
        return r.pId == pid;
      });
      if (rootNode && rootNode.length > 0) {
        rootNode.forEach((element) => {
          element.onlineCount = 0;
          element.totalCount = 0;

          //计算在线数量和总数
          if (element.treeLevel && element.treeLevel == 5) {

            if (element.isOnLine != 0) element.onlineCount += 1;
            element.totalCount += 1;
            this.vids.push(element.nodeValue);
          }

          var result = this.loopVehicleTree(element.id, source);
          if (result) {
            element.children = result[0];
            element.onlineCount += result[1];
            element.totalCount += result[2];
          }
          online += element.onlineCount;
          total += element.totalCount;
          data.push(element);
        });
      }
      return [data, online, total];
    },
    onVelOnlineStateAck(data) {
      //更新车辆的在线状态
   
      if (data.count) data.count = parseInt(data.count);

      for (var i = 0; i < data.count; i++) {
        var vid = data.param[i * 2];
        var onlinestate = data.param[i * 2 + 1];
        //0 离线 1 在线 3 不知道什么意思
        this.$store.dispatch('app/updateVehicleOnline', { id: "C" + (vid), online: parseInt(onlinestate) });// 
      }
    }
  },
  mounted() {
    //从接口获取
    this.vids = [];

    if (this.vehicles.data.length == 0) {
   
      this.$api.LoadVehicleTreeInfo().then((res) => {
        //生成对象，保存到store
        var tree = {};
        res.forEach((element) => {
          element.isChecked = false;
          tree[element.id] = element;
        });
        this.$store.dispatch("app/updateVehicleTree", {
          tree,
          rootId: res[0].id,
        });

        this.$store.dispatch("app/updateVehicleData", res);
        this.initTreeData();
      });
    } else {
      this.initTreeData();
    }

    this.$bus.$on("initVehicleTree", () => {
      this.initTreeData();
    });
    if (this.timerOnline)
      clearInterval(this.timerOnline);

    this.socketClient.AttachEvent(
      "VelOnlineStateReq",
      this.socketClient.eventType.onVelOnlineStateAck,
      this.onVelOnlineStateAck
    );

    //定时器，1分钟一次，通过websocket获取车辆的在线状态
    this.timerOnline = setInterval(() => {
      // setTimeout(() => {
      //  console.log(this.vids);
      // //获取所有车辆ID
      // if (this.vids.length == 0)
      //   this.vehicles.data.forEach((element) => {
      //     this.vids.push(element.nodeValue);
      //   });
      var total = this.vids.length;//总数
      var paras = this.vids;//车辆id
      this.socketClient.socket.VelOnlineStateReq(total,
        paras
      );
      // }, 10 * 1000);
    }, 30 * 1000);

    //更新某个车辆的在线情况

    //
    // setTimeout(() => {
    //     this.$store.dispatch('app/updateVehicleOnline', { id: "86892", online: 1 });
    //     // {{ vehicles.selectedVehicles.length }}
    // }, 5000);

    setTimeout(() => {
      //更新， 重新加载
      // this.$api.LoadVehicleTreeInfo().then(res => {
      //     //生成对象，保存到store
      //     var tree = {};
      //     res.forEach(element => {
      //         element.isChecked = false;
      //         tree[element.id] = element;
      //     });
      //     this.$store.dispatch('app/updateVehicleTree', { tree, rootId: res[0].id });
      //     this.$store.dispatch('app/updateVehicleData', res);
      //     this.initTreeData()
      // });
      //getVehicles
      //  this.$store.dispatch('app/updateVehicleGroup', { vids: "23489,79834,79838", groupid: 7891 });
      // var vids = "86892,106312";
      // var groupid = 26074;
      // var lineNode = this.$refs.tree.getNode(groupid)
      // if (lineNode) {
      //     vids.split(',').forEach(vid => {
      //         var c = this.$refs.tree.getNode('C' + vid);
      //         console.log(c)
      //         if (c) {
      //             this.$refs.tree.remove(c)
      //             this.$refs.tree.append(c.data, lineNode)
      //         }
      //     });
      // }
      // {{ vehicles.selectedVehicles.length }}
    }, 2000);
  },
};
</script>
<style lang="scss" scoped>
.vehicle_tree {
  .tree_folder {
    font-weight: bold;
    font-size: 12px;
    color: #0f1a3a;
    letter-spacing: 0;
    line-height: 12px;
  }

  .tree_file {
    font-size: 12px;
    color: #0f1a3a;
    letter-spacing: 0;
    line-height: 12px;
    max-width: calc(100% - 20px);
    /* 留出一些空间给图标和复选框 */

    .iconfont {
      color: #a2b1cb;
      margin-right: 8px;
    }
  }

  .search_vehicle_item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 15px;
    border-bottom: 1px solid #c7d6f3;
  }

  .search_vehicle_item:hover {
    background: #d9e4f8;
  }

  .online {
    .iconfont {
      color: #07b477;
    }
  }

  .header {
    display: flex;
    text-align: left;

    span {
      display: inline-block;
      flex: 1;
      font-size: 14px;
      color: #0f1a3a;
      letter-spacing: 0;
      line-height: 14px;
      font-weight: bold;
    }
  }
}

.toggle_icon {
  color: #000;
  font-size: 20px;
  cursor: pointer;
}

.is-checked span {
  color: #2a7aff !important;
}

.is-checked i {
  color: #2a7aff !important;
}
</style>
